import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { useAppStore } from '../store/appStore';

export const SignIn: React.FC = () => {
  const navigate = useNavigate();
  const [code, setCode] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const { loginWithCode } = useAppStore();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!code.trim()) return;

    setIsLoading(true);
    setError(null);

    try {
      const success = await loginWithCode(code);
      if (success) {
        navigate('/dashboard');
      } else {
        setError('Ugyldig kode');
      }
    } catch {
      setError('Noe gikk galt. Prøv igjen.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0a0a0a] flex items-center justify-center p-6">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-white tracking-tight">Scenechat</h1>
        </div>
        <Card className="bg-[#1a1a1a] border-none">
          <CardContent className="p-6">
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label htmlFor="code" className="block text-white text-sm mb-2">
                  Skriv inn koden din
                </label>
                <input
                  type="password"
                  id="code"
                  value={code}
                  onChange={(e) => setCode(e.target.value)}
                  placeholder="Skriv koden her"
                  className="w-full p-4 rounded-lg bg-[#2a2a2a] text-white border-none focus:ring-2 focus:ring-white/50 placeholder-gray-500"
                  autoFocus
                  disabled={isLoading}
                />
              </div>
              {error && (
                <div className="bg-red-500/10 border border-red-500/20 text-red-400 px-4 py-3 rounded-lg text-sm">
                  {error}
                </div>
              )}
              <Button
                type="submit"
                className="w-full bg-white text-black font-semibold py-4 sm:py-6 hover:bg-gray-200"
                disabled={isLoading || !code.trim()}
              >
                {isLoading ? 'Logger inn...' : 'Logg inn'}
              </Button>
            </form>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};
